import { Command } from 'prosemirror-state';

import { MENTIONS_PLUGIN_KEY } from './consts';

export const closeDialog: Command = (state, dispatch) => {
  if (dispatch) {
    const metaData = MENTIONS_PLUGIN_KEY.getState(state);
    dispatch(state.tr.setMeta(MENTIONS_PLUGIN_KEY, { ...metaData, open: false, terminated: true }));

    return true;
  }

  return false;
};
